export default "__VITE_ASSET__phofjhpo__"